var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDragHandle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .a {\r\n                fill: inherit;\r\n            }\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-484 -2875)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(484 2875)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(484 2893)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(484 2884)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(493 2875)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(493 2893)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(493 2884)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragHandle);
export default __webpack_public_path__ + "static/media/drag-handle.ea52a91f.svg";
export { ForwardRef as ReactComponent };